import { Platform, requireNativeComponent, UIManager } from 'react-native';

// Keep registration outside the refreshable React component module. Re-running
// requireNativeComponent for a registered name throws during Fast Refresh.
let nativeBackground;
export function getMacModalBackgroundView() {
  if (Platform.OS !== 'macos') return null;
  if (!nativeBackground && UIManager.getViewManagerConfig('MacModalBackgroundView')) {
    nativeBackground = requireNativeComponent('MacModalBackgroundView');
  }
  return nativeBackground || null;
}
